import { Component, OnInit, OnDestroy, ViewChild, TemplateRef, Input, AfterViewInit, Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductService } from "../../../services/product.service";
import { LoginService } from "../../../../mylogin/loginc/login.service";
import { GlobalobjectsService } from "../../../../globalobjects.service";
import { Router } from "@angular/router";
import { Product } from "../../../classes/product";
import { Observable } from 'rxjs';

@Component({
  selector: 'app-pre-cart-review-modal',
  templateUrl: './pre-cart-review-modal.component.html',
  styleUrls: ['./pre-cart-review-modal.component.scss']
})
export class PreCartReviewModalComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild("preCartReviewModal", { static: false }) PreCartReviewModal: TemplateRef<any>;

  public closeResult: string;
  public modalOpen: boolean = false;
  
  
  public mproducts: Product[] = []; 
  public missinpromoproducts: Product[] = []; 
  public aproducts: Product[] = []; 
  public products: Product[] = []; 
  
  
  public grid: string = "col-xl-3 col-6";
  public pmigrid: string = "col-xl-6 col-6";
  public layoutView: string = "grid-view";
  
  
  public missingitems = [];

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private modalService: NgbModal,
    public productService: ProductService,
    private loginService: LoginService,
    public Globalobjects: GlobalobjectsService,
    private router: Router
  ) {
    
    this.productService.getProducts.subscribe(
      (response) => (this.aproducts = response)
    );

    this.aproducts =  this.aproducts.filter(product => product.isPriceGroup);


    this.productService.cartItems.subscribe((response) => {
      this.products = response;
      this.loadMissingPromoItems();
    });
    
    this.productService.MissingPromoProducts.subscribe(
      (response) => { this.missinpromoproducts = response; }
    );
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

  async openModal() {
    
    await this.loadMissingLastOrderItems();
    await this.loadMissingPromoItems();
    
    this.modalOpen = true;
    if (isPlatformBrowser(this.platformId)) {
      this.modalService.open(this.PreCartReviewModal, { 
        size: 'xl',
        ariaLabelledBy: 'Pre-Cart-Review-Modal',
        windowClass: 'theme-modal pre-cart-review-modal',
        scrollable: true
      }).result.then((result) => {
        `Result ${result}`
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });

      
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
      }, 100);

      
      setTimeout(() => {
        const selectors = [
          '.theme-modal.pre-cart-review-modal .modal-body',
          '.theme-modal.pre-cart-review-modal .modal-content',
          '.theme-modal.pre-cart-review-modal .modal-dialog'
        ];
        selectors.forEach(sel => {
          const el = document.querySelector(sel);
          if (el) {
            (el as HTMLElement).scrollTop = 0;
          }
        });
      }, 100);
    }
  }

  
  loadMissingLastOrderItems() {
    const data = {
      countryList_Id: localStorage.getItem("country"),
      customerNumber: localStorage.getItem("customerNumber"),
    };

    this.loginService.getCustomerLastOrder(data).subscribe((response: any) => {
      if (response.apiStatus.isSuccess) {
        
        const localStorageItems: Product[] = this.products;

        
        const localStorageIds = new Set(this.products.map((item) => item.id));

        
        this.missingitems = response.orderDetail.filter(
          (apiItem) => !localStorageIds.has(apiItem.lineObjectNumber)
        );

        
        
        const missingItemIds = new Set(
          this.missingitems.map((item) => item.lineObjectNumber)
        );

        
        this.mproducts = this.aproducts.filter((apiItem) =>
          missingItemIds.has(apiItem.id) 
        );
      }
    });
  }

  
  loadMissingPromoItems() {
    const promotiondata = JSON.parse(localStorage.getItem("promotiondata") || '[]');
    let allMissingItems: string[] = [];

    
    promotiondata.forEach((promotion) => {
      if (promotion.isActive && promotion.isApply_MinQty) {
        let missingItems: string[] = [];

        promotion.promotion_Items.forEach((item) => {
          if (item.isInput) {
            
            const isMissing = !this.products.some((cartItem) => cartItem.id === item.itemNumber);
            if (isMissing) {
              missingItems.push(item.itemNumber);
            }
          }
        });

        
        allMissingItems = [...allMissingItems, ...missingItems];
      }
    });

    
    allMissingItems = [...new Set(allMissingItems)];

    const allproducts = JSON.parse(localStorage.getItem("products") || '[]');
    this.missinpromoproducts = allproducts.filter((apiItem) => allMissingItems.includes(apiItem.id));
  }

  
  continueToCart() {
    if (this.modalOpen) {
      this.modalService.dismissAll();
    }
    this.router.navigate(['/shop/cart']);
  }

  
  async addToCartAndContinue(product: any) {
    const status = await this.productService.addToCart(product);
    if (status) {
      
      this.loadMissingLastOrderItems();
      this.loadMissingPromoItems();
    }
  }

  
  async addToCartWithQuantity(product: any, quantity: number) {
    const status = await this.productService.addToCartC(product, quantity);
    if (status) {
      
      this.loadMissingLastOrderItems();
      this.loadMissingPromoItems();
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnDestroy() {
    if (this.modalOpen) {
      this.modalService.dismissAll();
    }
  }
}
